import { useMe } from '@/context/me/me.context';
import { useGetIntercomIsVisible } from '@/queries/layout.queries';
import envService from '@/services/env.service';
import Intercom, { update } from '@intercom/messenger-js-sdk';
import { useEffect } from 'react';

export default function IntercomComponent() {
  const env = envService.getEnv();
  const intercomAppId = env.VITE_INTERCOM_ID;
  const { data: userData } = useMe();
  const { data: isIntercomVisible } = useGetIntercomIsVisible();

  // Handle toggling launcher visibility on context change
  useEffect(() => {
    if (!isIntercomVisible) {
      update({ hide_default_launcher: true });
    } else {
      update({ hide_default_launcher: false });
    }
  }, [isIntercomVisible]);

  // Handle updating user data on context change
  useEffect(() => {
    update({
      user_id: userData?.account?.id,
      name: userData?.profile?.name,
      email: userData?.account?.credential,
      user_hash: userData?.intercomUserHash,
    });
  }, [userData]);

  Intercom({
    app_id: intercomAppId,
    user_id: userData?.account?.id,
    name: userData?.profile?.name,
    email: userData?.account?.credential,
    user_hash: userData?.intercomUserHash,
    z_index: 2000,
  });

  return null;
}
